import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { CreateUserParams, CreateUserResponse, createUser } from '@utils/backend-api/users';

export default function useTeamUserCreate() {
  const { mutateAsync, data, isLoading, isError } = useMutation(
    (params: CreateUserParams) => createUser(params, {}),
    {
      onSuccess: (response: CreateUserResponse) => {
        if (!response.isNewUser) {
          toast.error(response.message);
          window.location.href = response.location;
        }
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutateAsync, data, isLoading, isError };
}
